import { NextPageContext } from 'next';
import Head from 'next/head';
import { generateSimpleStructuredData } from 'common/utils';
import { generateCookieList } from 'common/utils/trackingTag';
import AboutPageLayout from 'components/v2/layouts/about-page-layout';
import FeaturedArticle from 'components/v2/molecules/featured-article';
import ArticleGrid from 'components/v2/organisms/article-grid';
import { parse } from 'cookie';
import creatorsIndex from 'data/article/creator/index';

const AboutCreatorPage = () => {
  const metadata = {
    title: 'クリエイター成功事例 | PostPrime - 投資家の成長ストーリー',
    description:
      'PostPrimeクリエイターの成功事例とインサイト。初心者からプロ投資家へ成長した実話、独自の投資戦略、失敗から学んだ教訓を公開。あなたの投資の道しるべとなる、リアルな成長ストーリー。',
    image: 'https://assets.postprime.com/internals/pp_og.png',
    url: 'https://postprime.com/about/creator',
    keywords:
      'PostPrime, クリエイター, 投資家, 成長ストーリー, 初心者, プロ投資家, 投資戦略, 失敗から学んだ教訓, 投資の道しるべ, リアルな成長ストーリー, AI推薦システム, 投資コミュニティ, 投資教育, ファイナンシャルリテラシー, 資産運用, 新NISA, つみたてNISA, 日本株, 米国株, 投資インサイト, 投資ノウハウ, 投資体験談, 投資アドバイス, 投資成功事例, 投資失敗談, ポートフォリオ構築, リスク管理, 投資心理学, マーケット分析',
  };

  return (
    <>
      <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={metadata.url} />
        <meta property="og:title" content={metadata.title} />
        <meta property="og:description" content={metadata.description} />
        <meta property="og:image" content={metadata.image} key="og:image" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content={metadata.title} />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={metadata.url} />
        <meta property="twitter:title" content={metadata.title} />
        <meta property="twitter:description" content={metadata.description} />
        <meta property="twitter:image" content={metadata.image} />

        <meta name="keywords" content={metadata.keywords} />
        <link rel="canonical" href={metadata.url} />
        {/* JSON-LD Structured Data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: generateSimpleStructuredData(metadata),
          }}
        />
      </Head>
      <AboutPageLayout>
        <div className="mx-auto max-w-[1000px] px-5 py-10 md:py-20 lg:px-10">
          {/* Page Header */}
          <div className="mb-10 md:mb-20">
            <h1 className="mb-4 text-5xl font-bold tracking-tight text-pp-text-primary">
              クリエイター
            </h1>
            <p className="text-xl text-pp-text-secondary">
              初心者を、明日のプロ投資家へ
            </p>
          </div>

          {/* Featured Article */}
          <FeaturedArticle article={creatorsIndex.highlight} />

          {/* Articles Grid */}
          <ArticleGrid articles={creatorsIndex.articles || []} />
        </div>
      </AboutPageLayout>
    </>
  );
};

export const getServerSideProps = (context: NextPageContext) => {
  const cookiesList = generateCookieList(
    context.query,
    parse(context.req?.headers?.cookie || ''),
  );
  if (cookiesList.length > 0) {
    context.res.setHeader('Set-Cookie', cookiesList);
  }
  return {
    props: {},
  };
};

export default AboutCreatorPage;
